"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogCarousel = exports.BLOG_CAROUSEL_SELECT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const BlogCarouselView_1 = require("./BlogCarouselView");
exports.BLOG_CAROUSEL_SELECT = {
    slug: true,
    image: true,
    title: true,
    category: { title: true, slug: true },
};
function BlogCarousel(_a) {
    var viewProps = __rest(_a, []);
    const { data, loading } = (0, app_1.useQuery)('getArticles', {
        select: exports.BLOG_CAROUSEL_SELECT,
    });
    if (loading) {
        return (0, jsx_runtime_1.jsx)(ui_1.Loading, {});
    }
    if (!data) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(BlogCarouselView_1.BlogCarouselView, Object.assign({ articles: data }, viewProps));
}
exports.BlogCarousel = BlogCarousel;
